import React from 'react';
import { createBrowserRouter, createRoutesFromElements, Route } from 'react-router-dom';
import AuthProvider from './UI/layout_providers/auth_provider';
import SignInLayout from '@layouts/signin';
import ModalContextProvider from './context/modal_context';
import { routes } from '@const/routes';
import TransactionsLayout from '@layouts/transactions';
import GlobalProvider from './UI/layout_providers/global_provider';
import ConsumersLayout from '@layouts/consumers';
import LogsLayout from '@layouts/logs';
import TicketsLayout from '@layouts/tickets';
import ConsumerLayout from '@layouts/consumers/consumer';
import { UserContextProvider } from './context/user_context';
import AdminsLayout from '@layouts/admins';
import AdminLayout from '@layouts/admins/admin';
import NotFoundPage from '@layouts/not_found';
import SignUpLayout from '@layouts/signup';
import LoyaltyLayout from '@layouts/loyalty';
import AgreementsLayout from '@layouts/agreements';
import AgreementLayout from '@layouts/agreements/agreement';
import LimitsLayout from '@layouts/limits';
import ProductsLayout from '@layouts/products';
import GiftCardsLayout from '@layouts/gift_cards';
import ExternalPaymentsLayout from '@layouts/external_payments';
import ComplianceGuard from './UI/layout_providers/compliance_guard';
import SuperAdminGuard from './UI/layout_providers/super_admin_guard';
import AdminAndAboveGuard from './UI/layout_providers/admin_and_above_guard';
import FundsFlowLayout from '@layouts/funds_flow';
import AmlAlertsLayout from '@layouts/aml/alerts';
import AmlAlertLayout from '@layouts/aml/alerts/alert';
import AmlCasesLayout from '@layouts/aml/cases';
import AmlCaseLayout from '@layouts/aml/cases/case';
import AmlSettingsLayout from '@layouts/aml/settings';
// TEMP-HIDE EPS (founder 2026-06-29) — restore to re-enable
// import EpsSettingsLayout from '@layouts/eps/settings';

export const router = createBrowserRouter(
    createRoutesFromElements(
        <Route element={<UserContextProvider />}>
            <Route element={<ModalContextProvider />}>
                <Route element={<AuthProvider />}>
                    <Route path={routes.signin} element={<SignInLayout />} />
                    <Route path={routes.forgot} element={<SignInLayout isForgot />} />
                    <Route path={routes.signup} element={<SignUpLayout />} />
                </Route>
                <Route element={<GlobalProvider />}>
                    <Route path={routes.transactions} element={<TransactionsLayout />} />
                    <Route path={routes.consumers} element={<ConsumersLayout />} />
                    <Route path={routes.consumer} element={<ConsumerLayout />} />
                    <Route path={routes.admins} element={<AdminsLayout />} />
                    <Route path={routes.loyalty} element={<LoyaltyLayout />} />
                    <Route path={routes.limits} element={<LimitsLayout />} />
                    <Route path={routes.products} element={<ProductsLayout />} />
                    <Route path={routes.admin} element={<AdminLayout />} />
                    <Route path={routes.logs} element={<LogsLayout />} />
                    <Route path={routes.tickets} element={<TicketsLayout />} />
                    <Route path={routes.agreements} element={<AgreementsLayout />} />
                    <Route path={routes.agreement} element={<AgreementLayout />} />
                    <Route path={routes.gift_cards} element={<GiftCardsLayout />} />
                    <Route path={routes.external_payments} element={<ExternalPaymentsLayout />} />
                    <Route element={<ComplianceGuard />}>
                        <Route path={routes.aml_alerts} element={<AmlAlertsLayout />} />
                        <Route path={routes.aml_alert} element={<AmlAlertLayout />} />
                        <Route path={routes.aml_cases} element={<AmlCasesLayout />} />
                        <Route path={routes.aml_case} element={<AmlCaseLayout />} />
                    </Route>
                    <Route element={<AdminAndAboveGuard />}>
                        <Route path={routes.funds_flow} element={<FundsFlowLayout />} />
                    </Route>
                    <Route element={<SuperAdminGuard />}>
                        <Route path={routes.aml_settings} element={<AmlSettingsLayout />} />
                        {/* TEMP-HIDE EPS (founder 2026-06-29) — restore to re-enable */}
                        {/* <Route path={routes.eps_settings} element={<EpsSettingsLayout />} /> */}
                    </Route>
                    <Route path="*" element={<NotFoundPage />} />
                </Route>
            </Route>
        </Route>
    )
);
